export default __webpack_public_path__ + "static/media/counter-icon-4.179fe5bc.svg";